import "./biography.css";

const Biography = () => {
  return (
    <div className="left-side-biography">
      <h4>Biography</h4>{" "}
    </div>
  );
};

export default Biography;
